import { render } from "./InsuranceButton.vue?vue&type=template&id=d47e9118&scoped=true"
import script from "./InsuranceButton.vue?vue&type=script&lang=js"
export * from "./InsuranceButton.vue?vue&type=script&lang=js"

import "./InsuranceButton.vue?vue&type=style&index=0&id=d47e9118&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d47e9118"]])

export default __exports__